import { GameType, Stage, StagePack } from '../types'

import { getRandomInt } from './drafter'

import MeleeStagePacks from '../stages/meleeStagePacks.json'
import UltimateStageData from '../stages/ultimateStageData.json'

export const StageDraftTypes = {
  ALL: 'all',
  STANDARD: 'standard',
  MEME: 'meme'
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type StageDraftTypes = typeof StageDraftTypes[keyof typeof StageDraftTypes]

export const DraftStage = (
  draftType: StageDraftTypes,
  gameType: GameType,
  stagePack: StagePack,
  memeStageChance?: number
): Stage => {
  let mapList: Stage[] = [];

  if (draftType === StageDraftTypes.ALL) {
    let changeForGettingMemeMap = memeStageChance ? memeStageChance : 20;
    const rngResult = getRandomInt(100);

    if (rngResult <= changeForGettingMemeMap) {
      mapList = AppendStageSubList(StageDraftTypes.MEME, mapList, gameType, stagePack);
    } else {
      mapList = AppendStageSubList(StageDraftTypes.STANDARD, mapList, gameType, stagePack);
    }
  } else {
    mapList = AppendStageSubList(draftType, mapList, gameType, stagePack);
  }

  const mapPick = getRandomInt(mapList.length);
  const stageResult = mapList[mapPick];

  return {
    Name: stageResult.Name,
    Image: stageResult.Image
  };
}
export function AppendStageSubList(
  subList: ('standard' | 'meme'),
  mapList: Stage[],
  gameType: GameType,
  stagePack: StagePack
) {
  // Legacy DraftOptions saved before stagePack existed default to the
  // mod pack — that was the only available pack pre-migration.
  const pack: StagePack = MeleeStagePacks[stagePack] ? stagePack : 'stageMod';
  var data = gameType === GameType.Melee
    ? Object.entries(MeleeStagePacks[pack][subList])
    : Object.entries(UltimateStageData[subList]);

  for (const [, [key, value]] of Object.entries(data)) {
    mapList.push({
      Name: key,
      Image: value
    })
  }
  return mapList;
}

export const IsCompetetiveStage = (stage: Stage, gameType: GameType, stagePack: StagePack): boolean => {
  let competetiveStages: Stage[] = [];
  competetiveStages = AppendStageSubList(StageDraftTypes.STANDARD, competetiveStages, gameType, stagePack);
  let exists = false;
  competetiveStages.forEach(s => {
    if (s.Name === stage.Name) {
      exists = true;
      return exists;
    }
  })

  return exists;
}

export const GetFullStageList = (gameType: GameType, stagePack: StagePack): Stage[] => {
  let mapList: Stage[] = [];
  mapList = AppendStageSubList('standard', mapList, gameType, stagePack);
  mapList = AppendStageSubList('meme', mapList, gameType, stagePack);
  return mapList;
}

export const GetStage = (name: string, gameType: GameType, stagePack: StagePack) => {
  const stageList = GetFullStageList(gameType, stagePack);
  let foundStage = null;
  for (let i = 0; i < stageList.length; i++) {
    const temp = stageList[i];
    if (temp.Name === name) {
      foundStage = temp;
      return foundStage;
    }
  }
  return foundStage;
}
